///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Action, ActionReducer, MetaReducer } from '@ngrx/store';
import { LOGOUT } from './meta-actions';

export const metaReducers: MetaReducer[] = [clearStateMetaReducer];

export function clearStateMetaReducer<State extends object>(reducer: ActionReducer<State>): ActionReducer<State> {
    return function clearStateFn(state: State, action: Action) {
        if (action.type === LOGOUT) {
            state = {
                systemInfo: state['systemInfo']
            } as State;
        }
        return reducer(state, action);
    };
}
